import appGlobalScript from '/home/diegogoncalves/Documents/Sydle/service-desk-components/packages/service-desk-components/src/global/app.ts';
export const globalScripts = appGlobalScript;
